//src/components/Admin/Layout/AdminLayout.tsx
import React, { useState } from "react";
import { Box, CssBaseline, Toolbar, useTheme, useMediaQuery } from "@mui/material";
import Sidebar from "../SideBar/SideBar";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Outlet } from "react-router-dom";

const AdminLayout: React.FC = () => {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex"}}>
      <CssBaseline />

      {/* Header */}
      <Header onDrawerToggle={handleDrawerToggle} />

      {/* Sidebar with responsive variants */}
      <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflowX: "hidden", // Prevent horizontal scrolling
        }}
      >
        {/* Spacer for fixed header */}
        <Toolbar />

        {/* Page Content */}
        <Box component="main" sx={{ flexGrow: 1, p: 3, overflowY: "hidden" }}>
          <Outlet />
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </Box>
  );
};

export default AdminLayout;
